import { useEffect } from "react";

// Тримає екран увімкненим, доки активний — ведучий регулярно дивиться
// в екран під час гри, і гаснучий екран заважає. Wake Lock звільняється
// автоматично, коли вкладка згортається, тож перезапитуємо його при
// поверненні у видиму вкладку.
export default function useWakeLock(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    if (!("wakeLock" in navigator)) return undefined;

    let wakeLockSentinel = null;
    let cancelled = false;

    async function requestLock() {
      try {
        wakeLockSentinel = await navigator.wakeLock.request("screen");
      } catch (e) {
        // Може відмовити (напр. режим економії заряду) — не критично для роботи.
        console.error(e);
      }
    }

    function handleVisibilityChange() {
      if (!cancelled && document.visibilityState === "visible") {
        requestLock();
      }
    }

    requestLock();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (wakeLockSentinel) {
        wakeLockSentinel.release().catch(() => {});
      }
    };
  }, [enabled]);
}
